import constants from "../constants/constants";
import errorHandle from "../../utils/errorHandle";

const {
  GET_TOKENS, GET_TOKENS_SUCCESS, GET_TOKENS_ERROR,
} = constants;

const initialState = { loading: false, gdTokens: 0, error: '' }

export const tokensReducer = (state = initialState, action) => {
  const { type, gdTokens, error } = action;
  switch (type) {
    case GET_TOKENS:
      return { loading: true }
    case GET_TOKENS_SUCCESS:
      return { loading: false, gdTokens }
    case GET_TOKENS_ERROR:
      return { loading: false, error: errorHandle(error) }

    default:
      return state
  }
}
